/* Add lightbox to gallery images (post/page bundle only) */
(function () {
    lightbox(
        '.kg-image-card > .kg-image[width][height], .kg-gallery-image > img'
    );
})();
